var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 6.917a1 1 0 1 1 0 2H9.414l8.293 8.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068L8 10.331v7.586a1 1 0 1 1-2 0v-10q0-.12.027-.231l.016-.062a1 1 0 0 1 .122-.257c.09-.137.214-.251.36-.33l.041-.02a1 1 0 0 1 .14-.057l.062-.016.035-.007.005-.001.09-.014A1 1 0 0 1 7 6.917z"
  })));
};
export default Svg24;